// extracted by mini-css-extract-plugin
export var content = "styles-module--content--a1adf";
export var content_body = "styles-module--content_body--f3534";
export var content_link_container = "styles-module--content_link_container--fef66";
export var description = "styles-module--description--401d3";
export var icon = "styles-module--icon--7a8f9";
export var image = "styles-module--image--a2781";
export var image_container = "styles-module--image_container--71223";
export var root = "styles-module--root--cc978";
export var title = "styles-module--title--cb97d";
export var why_learn_body = "styles-module--why_learn_body--35ce2";
export var why_learn_footer = "styles-module--why_learn_footer--c3ab2";
export var why_learn_footer_features = "styles-module--why_learn_footer_features--5e4d6";
export var why_learn_footer_features_item = "styles-module--why_learn_footer_features_item--b22d6";
export var why_learn_footer_features_list = "styles-module--why_learn_footer_features_list--4f7d3";
export var why_learn_footer_features_title = "styles-module--why_learn_footer_features_title--833d0";
export var why_learn_root = "styles-module--why_learn_root--d5bad";